import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=4a4fa8b1&scoped=true"
import script from "./Clause.vue?vue&type=script&lang=js"
export * from "./Clause.vue?vue&type=script&lang=js"
import style0 from "./Clause.vue?vue&type=style&index=0&id=4a4fa8b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4fa8b1",
  null
  
)

export default component.exports